<template>
  <div class="hy-list-page">
    <div class="top-page-all">
      <div @click="onClickLeft" class="ret-btn"><</div>
      <div>会员申请列表</div>
    </div>
    <div class="top-bg-st"></div>
    <div class="my-item list-title">
      <div class="my-lab">会员申请列表</div>
    </div>
    <div class="syb-item title-clr">
      <div class="title-clr-c">
        <div style="border-right: 1px solid #eee">用户名</div>
        <div style="border-right: 1px solid #eee">卡类型</div>
        <div style="border-right: 1px solid #eee">状态</div>
        <div style="border-right: 1px solid #eee">申请理由</div>
      </div>

    </div>
    <div v-if="!HYList.length" class="content-box" style="padding-top: 1rem;text-align: center;">暂无记录</div>
    <div  v-if="HYList.length" class="content-box"  v-bottom-load="{handle: getHY, distance: 30}">
      <div @click="activeIndex=index" :class="{'activeText':activeIndex === index}" class="syb-item content-item-box" v-for="(item,index) in HYList">
        <div class="item" style="border-right: 1px solid #eee">{{item.nickname}}</div>
        <div class="item"  style="border-right: 1px solid #eee">{{selectList[item.type-1]}}</div>
        <div class="item"    :class="{'red':item.status == -1}" style="border-right: 1px solid #eee">{{getStata(item.status)}}</div>
        <div class="item"  style="border-right: 1px solid #eee">{{item.reason}}</div>
        <div @click.stop="activeIndex = -1" v-if="activeIndex == index" class="content-item-ab-mb"></div>
        <div @click="nuFn" v-if="activeIndex == index" class="content-item-ab">
           <div class="content-item-ab-list">用户名：{{item.nickname}}</div>
          <div class="content-item-ab-list">
            卡密：{{item.secret}}
            <div class="copy"  :data-clipboard-text="item.secret" @click="copy" v-if="item.status == 2">
              <img src="//qn.xwyyjt.com/ht_xw_link.png" alt="">
              一键复制
              </div>
          </div>
          <div class="content-item-ab-list">状态：{{selectList[item.type-1]}}</div>
          <div class="content-item-ab-list">申请理由：{{item.reason}}</div>
          <div class="content-item-ab-list">拒绝理由：{{item.liyou}}</div>
          <div class="content-item-ab-list">创建时间：{{timeFormat(item.create_time)}}</div>
          <div class="content-item-ab-list">审核时间：{{timeFormat(item.update_time)}}</div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
  export default {
    name: "hyList",
    data() {
      return {
        selectList: ['周卡', '月卡', '季度卡', '年卡'],
        HYList: '',
        total: '',
        page: 0,
        key: true,
        end: false,
        activeIndex:-1,
      }
    },
    mounted() {
      this.getHY();
    },
    methods: {
      nuFn() {

      },
      copy() {
        var that = this
          var clipboard = new ClipboardJS('.copy');
          console.log(clipboard)
          clipboard.on('success', function (e) {
            console.log(e)
            that.$toast('复制成功');
            e.clearSelection();
          });
          clipboard.on('error', function (e) {
            console.log(e)
            that.$toast('复制失败，请手动复制');
          });

      },
      getStata(key) {
        let str='';
        switch(key) {
          case 1: str='待审核';break;
          case 2: str='通过';break;
          case -1: str='拒绝';break;
        }
        return str;
      },
      onClickLeft() {
        this.$router.go(-1);
      },

      getHY() {
        if (this.key && !this.end) {
          this.key = false;
          this.$http.post('secretlist', {
            token: window.localStorage.getItem('token'),
            limit: 20,
            page: this.page,
          }).then(
            (res) => {
              this.key = true;
              if (res.data.code == 200) {
                this.HYList = [...this.HYList, ...res.data.data.info];
                this.total = res.data.data.total;
                this.page++;
                this.end = !!(20 * this.page >= this.total)
              }else {
                this.$toast(res.data.msg || "系统错误");
              }
            }, (e) => {
              this.key = true;
            }
          )
        }
      },
    }
  }
</script>

<style lang="scss">

  .hy-list-page {
    .top-bg-st {
      position: relative;
      height: 2.4rem;
      width: 7.5rem;
      background-image: linear-gradient(to right, #038ED1, #1D208A);
    }

    .list-title {
      position: fixed;
      top: 1.24rem;
      left: 0;
      right: 0;
      color: #999999;
      font-size: .28rem;
      background: #ffffff;
      width: 6.86rem;
      margin: .24rem auto 0;
      height: .84rem;
      border-top-right-radius: .32rem;
      border-top-left-radius: .32rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 .32rem;
      box-sizing: border-box;
    }

    .title-clr {
      position: fixed;
      top: 2.1rem;
      left: 0;
      right: 0;
      overflow: auto;
      color: #999999;
      background: #ffffff;
      width: 6.86rem;
      box-sizing: border-box;
      margin: 0 auto;
      padding: 0 .24rem;
     .title-clr-c {
       font-size: .24rem;
       width: 100%;
       height:.72rem;display: flex;align-items: center;border-top: 1px solid #ebedf0;
       border-bottom: 1px solid #ebedf0;
       div {
         flex: 1;
       }
     }

    }
    .content-box {
      padding-left: .24rem;
      padding-right: .24rem;
      position: fixed;
      top: 2.86rem;
      left: 0;
      right: 0;
      bottom: 0.8rem;
      overflow: auto;
      color: #999999;
      background: #ffffff;
      border-bottom-right-radius: .32rem;
      border-bottom-left-radius: .32rem;
      width: 6.86rem;
      padding-bottom: 1.6rem;
      box-sizing: border-box;
      margin: 0 auto;
    }

    .syb-item {
      min-height: .72rem;
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      color: #999999;
      font-size: .32rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item {
        width: 24%;
        flex: 1;
        font-size: .24rem;
        word-wrap:break-word;
        text-align: center;
      }
    }


    .content-item-box {
      position: relative;
    }
    .content-item-ab-mb {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

    }
    .content-item-ab {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: #F4F1F4;
      padding: .34rem .46rem;
      text-align: left;
      font-size: .24rem;
      box-shadow: 0 .04rem .04rem rgba(0,0,0,.1);
      .content-item-ab-list {
        line-height: .42rem;
        display: flex;
      }
      .copy {
        margin-left: 1rem;
        height: .42rem;
        text-align: center;
        display: flex;
        align-items: center;
        img {
          width: .38rem;
          height: auto;
          margin-right: .12rem;
        }
      }

    }
    .activeText {
      z-index: 9;
      .item {
        color: #0000ff;
      }
    }

    .my-item {
      height: .72rem;
      border-bottom: 1px solid #ebedf0;
      line-height: .72rem;
      padding-left: .4rem;
      color: #999999;
      display: flex;
      align-items: center;
      font-size: .26rem;

      .my-lab {
        width: 100%;
      }
    }

  .red {
    color: red!important;
  }
    .blue {
      color: #0000ff!important;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/hyList.vue